module.exports = __webpack_public_path__ + "img/icon-not-listed.c1e92d4b.svg";